<template>
  <div style="flex-grow:4;">
    <div class="aplayer-time-wrap">
      <div v-html="artist" class="artist" v-if="!mini"></div>
      <div class="aplayer-time">
        <div class="aplayer-time-inner">
          <span class="aplayer-ptime" :style="{color:HQ?'#e15151':'var(--theme-color)'}">{{secondToTime(stat.playedTime)}}</span> /
          <span class="aplayer-dtime" style="color:#4f5b60;">{{secondToTime(stat.duration)}}</span>
        </div>
        <!-- <volume v-if="!$parent.isMobile" :volume="volume" :theme="theme" :muted="muted" @togglemute="$emit('togglemute')" @setvolume="v => $emit('setvolume', v)" /> -->
        <!-- <icon-button class="aplayer-icon-mode" icon="shuffle" :class="{ 'inactive': !shuffle }" @click.native="$emit('toggleshuffle')" /> -->
        <!-- <icon-button class="aplayer-icon-mode" :icon="repeat === 'repeat-one' ? 'repeat-one' : 'repeat-all'" :class="{ 'inactive': repeat === 'no-repeat'}" @click.native="$emit('nextmode')" /> -->
        <!-- <icon-button class="aplayer-icon-menu" icon="menu" :class="{ 'inactive': !$parent.showList }" @click.native="$emit('togglelist')" /> -->
      </div>
      <div class="aplayer-button" v-if="mini" @click="onClick" :style="{cursor:disabled?'not-allowed':'pointer'}" :class="[playing ? 'aplayer-pause' : 'aplayer-play',playing&&HQ?'hq-aplayer-pause':'hq-aplayer-play']">
      </div>
    </div>
    <div class="aplayer-controller">
      <div class="aplayer-button-normal" v-if="!mini" @click="onClick" :style="{cursor:disabled?'not-allowed':'pointer'}" :class="[playing ? 'aplayer-pause' : 'aplayer-play',playing&&HQ?'hq-aplayer-pause':'hq-aplayer-play']">
      </div>
      <v-progress :loadProgress="loadProgress" :playProgress="playProgress" :theme="theme" @dragbegin="val => $emit('dragbegin', val)" @dragend="val => $emit('dragend', val)" @dragging="val => $emit('dragging', val)" />
      <div></div>
    </div>
  </div>

</template>

<script>
import IconButton from "./aplayer-iconbutton.vue";
import VProgress from "./aplayer-controller-progress.vue";
import Volume from "./aplayer-controller-volume.vue";

export default {
  components: {
    IconButton,
    VProgress,
    Volume
  },
  props: {
    playing: {
      type: Boolean,
      default: false
    },
    mini: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    artist: {},
    shuffle: {},
    repeat: {},
    stat: {},
    theme: {},
    volume: {},
    muted: {}
  },

  computed: {
    loadProgress () {
      if (this.stat.duration === 0) return 0;
      return this.stat.loadedTime / this.stat.duration;
    },
    playProgress () {
      if (this.stat.duration === 0) return 0;
      return this.stat.playedTime / this.stat.duration;
    }
  },
  methods: {
    onClick () {
      if (this.disabled) {
        return;
      }
      if (!this.hasMovedSinceMouseDown) {
        this.$emit("toggleplay");
      }
    },
    secondToTime (second) {
      if (isNaN(second)) {
        return "00:00";
      }
      const pad0 = num => {
        return num < 10 ? "0" + num : "" + num;
      };

      const min = Math.trunc(second / 60);
      const sec = Math.trunc(second - min * 60);
      const hours = Math.trunc(min / 60);
      const minAdjust = Math.trunc(
        second / 60 - 60 * Math.trunc(second / 60 / 60)
      );
      return second >= 3600
        ? pad0(hours) + ":" + pad0(minAdjust) + ":" + pad0(sec)
        : pad0(min) + ":" + pad0(sec);
    }
  }
};
</script>

<style lang="scss">
.aplayer-controller {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 5px;
}
.aplayer-time-wrap {
  height: 30px; //35
  display: flex;
  justify-content: space-between;
}
.artist {
  font-size: 14px;
  align-self: center;
  // text-indent: -.5em;
}
.aplayer-time {
  // display: flex;
  // width: 100%;
  position: relative;
  height: 17px;
  color: #999;
  font-size: 11px;
  align-self: center;
  text-align: right;
  padding-left: 3px;
  span {
    font-size: 14px;
  }
  .aplayer-volume-wrap {
    margin-left: 4px;
    margin-right: 4px;
  }

  .aplayer-icon {
    cursor: pointer;
    transition: all 0.2s ease;
    margin-left: 4px;

    &.inactive {
      opacity: 0.3;
    }

    .aplayer-fill {
      fill: #666;
    }

    &:hover {
      .aplayer-fill {
        fill: #000;
      }
    }

    &.aplayer-icon-menu {
      display: none;
    }
  }
  .aplayer-volume-wrap + .aplayer-icon {
    margin-left: 0;
  }

  &.aplayer-time-narrow {
    .aplayer-icon-mode {
      display: none;
    }

    .aplayer-icon-menu {
      display: none;
    }
  }
}
.aplayer-button {
  border-radius: 50%;
  transition: all 0.1s ease;
  align-self: center;
  .aplayer-fill {
    fill: #fff;
  }
}

.aplayer-play {
  width: 20px;
  height: 20px;
  // border: 2px solid #fff;
  background: url("../assets/play.png") no-repeat;
  background-position: center center;
  cursor: pointer;
  z-index: 9;
  &.hq-aplayer-play {
    background: url("../assets/hq-play.png") no-repeat;
     &:hover{
    background: url("../assets/hq-play-active.png") no-repeat;

    }
  }
}

.aplayer-pause {
  width: 20px;
  height: 20px;
  // border: 2px solid #fff;
  background: url("../assets/pause.png") no-repeat;
  background-position: center center;
  cursor: pointer;
  z-index: 9;
  &.hq-aplayer-pause {
    background: url("../assets/hq-pause.png") no-repeat;
    &:hover{
    background: url("../assets/hq-pause-active.png") no-repeat;

    }
  }
}
.aplayer-button-normal {
  &.aplayer-pause,
  &.aplayer-play {
    width: 25px;
    height: 25px;
    margin-left: -6px;
    margin-right: 12px;
    background: url("../assets/play-big.png") no-repeat;
    background-size: cover;
  }
  &.aplayer-pause {
    background: url("../assets/pause-big.png") no-repeat;
    background-size: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aplayer/components/aplayer-controller.vue